// Command-palette navigation targets. Kept as data (not inline JSX) so a test can
// check every href against the routes declared in App.tsx.
import {
  LayoutDashboard,
  Building2,
  Database,
  Settings,
  Plus,
  Files,
  Sparkles,
  Users,
  Target,
  Zap,
  Gauge,
  MessageSquare,
  Wrench,
  ClipboardList,
  type LucideIcon,
} from 'lucide-react'

export interface PaletteDestination {
  id: string
  label: string
  href: string
  icon: LucideIcon
  keywords: string[]
  group: 'Navigation' | 'Quick Actions'
}

export const PALETTE_DESTINATIONS: PaletteDestination[] = [
  { id: 'dashboard', label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard, keywords: ['home', 'overview'], group: 'Navigation' },
  { id: 'coo-chat', label: 'Ask Sentinel', href: '/coo/chat', icon: MessageSquare, keywords: ['chat', 'question', 'ask', 'sentinel', 'ai'], group: 'Navigation' },
  { id: 'sites', label: 'Sites', href: '/sites', icon: Building2, keywords: ['buildings', 'locations'], group: 'Navigation' },
  { id: 'meters', label: 'Meters', href: '/meters', icon: Gauge, keywords: ['energy', 'consumption', 'monitoring'], group: 'Navigation' },
  { id: 'assets', label: 'Assets', href: '/assets', icon: Wrench, keywords: ['devices', 'installations', 'lighting', 'hvac', 'portfolio'], group: 'Navigation' },
  { id: 'targets', label: 'Targets', href: '/budget', icon: Target, keywords: ['budget', 'plan', 'goals'], group: 'Navigation' },
  { id: 'initiatives', label: 'Initiatives', href: '/initiatives', icon: Zap, keywords: ['actions', 'savings'], group: 'Navigation' },
  { id: 'work', label: 'Work', href: '/work', icon: ClipboardList, keywords: ['tasks', 'field ops', 'visits'], group: 'Navigation' },
  { id: 'files', label: 'Files', href: '/files', icon: Files, keywords: ['documents', 'uploads', 'attachments', 'artifacts', 'download'], group: 'Navigation' },
  { id: 'skills', label: 'Skills', href: '/skills', icon: Sparkles, keywords: ['recipes', 'instructions', 'agent', 'knowledge', 'how to'], group: 'Navigation' },
  { id: 'data', label: 'Data', href: '/data', icon: Database, keywords: ['reference', 'core data', 'countries', 'tariffs', 'emission factors', 'climate'], group: 'Navigation' },
  { id: 'users', label: 'Users', href: '/users', icon: Users, keywords: ['team', 'people'], group: 'Navigation' },
  { id: 'settings', label: 'Settings', href: '/settings', icon: Settings, keywords: ['config', 'preferences'], group: 'Navigation' },
  { id: 'add-site', label: 'Add Site', href: '/sites?action=add', icon: Plus, keywords: ['new', 'create'], group: 'Quick Actions' },
]
